import { PlainItemsSelector } from 'app/common/ui-next/plain-selector'
import { SalePointId } from 'app/common/types/id'

import {
  filterActions,
  useFilterOptionsLoadingByKey,
  useFilterOptions,
  useFilter,
} from '../../filterStore'

import { sortByTitle, emptyArray } from './helpers'

export const SalePointControl = () => {
  const ids = useFilter('salePointIds')
  const salePoints = useFilterOptions('salePoints')
  const loading = useFilterOptionsLoadingByKey('salePoints')

  return (
    <PlainItemsSelector
      id="salePoint"
      label="Точка продаж"
      header="Выбор точки продаж"
      pleaseSelectText="Все"
      items={salePoints}
      selection={ids.draft || emptyArray}
      defaultSelection={ids.default || emptyArray}
      onChange={(selected) =>
        filterActions.selectDraftSalePointIds(selected as Array<SalePointId> | undefined)
      }
      loading={loading}
      sortFunc={sortByTitle}
      skipUpperSpace
      multiple
    />
  )
}
